export enum SignFault {
  unknown = 'unknown',
  none = 'none',
  invalidparameters = 'invalidparameters',
  accessdeniedrp = 'accessdeniedrp',
  retry = 'retry',
  internalerror = 'internalerror',
  expiredtransaction = 'expiredtransaction',
  usercancel = 'usercancel',
  clienterror = 'clienterror',
  certificateerror = 'certificateerror',
  cancelled = 'cancelled',
  startfailed = 'startfailed',
  alreadyinprogress = 'alreadyinprogress',
  signvalidationfailed = 'signvalidationfailed',
  unknownuser = 'unknownuser',
  unknownfinalstatus = 'unknownfinalstatus',
}

export class SignFaultHelper {
  public static parse(value: string): SignFault {
    if (value in SignFault) {
      return SignFault[value as keyof typeof SignFault];
    }
    return SignFault.unknown;
  }
}
